import React from 'react';

const MalDiTestaIcon = ({ primaryColor, secondaryColor, width }) => {
  const strokePrimary = primaryColor || '#282828';
  const strokeSecondary = secondaryColor || '#ffcf38';
  // const strokePrimary = '#282828';
  // const strokeSecondary = primaryColor || '#ffcf38';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="MalDiTesta"
      data-name="MalDiTesta"
      viewBox="0 0 200 200"
      style={{ width }}
      // {...props}
    >
      <defs>
        <style>
          {`.cls-1,.cls-2{stroke:${strokeSecondary};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.cls-2{stroke:${strokePrimary}}`}
        </style>
      </defs>
      <path
        d="M84.53 95.53c-3.85 0-4.53 19.16-8.16 19.16-2.04 0-2.72-6.27-2.72-16.42 0-6.61 7.71-19.16 25.86-19.16s25.86 12.54 25.86 19.16c0 10.15-.68 16.42-2.72 16.42-3.63 0-4.08-17.79-6.81-17.79-3.06 0-4.12 1.27-16.33 1.36h0c-7.6 0-11.91-2.73-14.97-2.73"
        className="cls-2"
      />
      <path
        d="M122.64 114.69c.7 0 4.08-3.19 4.08 4.11s-3.4 12.54-6.81 9.58c0 11.52-5.48 14.47-7.74 17.65-5.05 5.42-5.07 6.97-12.67 6.97s-7.62-1.56-12.67-6.97c-2.26-3.19-7.75-6.14-7.75-17.65-3.4 2.96-6.81-2.28-6.81-9.58s3.38-4.11 4.08-4.11"
        className="cls-2"
      />
      <path
        d="M112.65 145.41s-.16 4.34 3.07 7.59M86.35 145.41s.16 4.34-3.07 7.59"
        className="cls-2"
      />
      <path
        d="m99.5 48-3.89 11.67h7.78L99.5 71.33M134.5 55.78l-9.72 9.72 7.78 3.89-9.73 7.78M80.06 77.17 76.17 65.5l-7.78 3.89-3.89-13.61"
        className="cls-1"
      />
    </svg>
  );
};

export default MalDiTestaIcon;
